import { render, staticRenderFns } from "./PapaSummaryGasAnalysis.vue?vue&type=template&id=af6b0dec&"
import script from "./PapaSummaryGasAnalysis.vue?vue&type=script&lang=ts&"
export * from "./PapaSummaryGasAnalysis.vue?vue&type=script&lang=ts&"
import style0 from "./PapaSummaryGasAnalysis.vue?vue&type=style&index=0&id=af6b0dec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports